import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "Refine Search", -1)

import { computed } from 'vue';
	import { useStore } from 'vuex';
	import { Hamburger, Close } from '@/svg/index.js';
	import { IStoreState } from '@/types.d';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
		text?: string
	}

	

	const store = useStore<IStoreState>();
	const isFilterOpen = computed(() => store.state.isFilterOpen);

	const handleClick = () => {
		if (store.state.isFilterOpen){
			document?.querySelector('html')?.classList.remove('disable-scrolling');
			store.commit('setFilterOpen', false);
		}
		else {
			document?.querySelector('html')?.classList.add('disable-scrolling');
			store.commit('setFilterOpen', true);
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(props.text ? 'button-solid' : 'uv-filters-handle'),
    onClick: handleClick
  }, [
    (props.text)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(props.text), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(isFilterOpen))
            ? (_openBlock(), _createBlock(_unref(Close), { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_unref(Hamburger)),
                _hoisted_1
              ], 64))
        ], 64))
  ], 2))
}
}

})